<template>
    <div class="index">
        <div class="flash">
            <div class="gg">
                <div><div class="topNav">解决方案</div></div>
                <div class="title">快消行业</div>
                <div class="minTitle">通过湖仓一体化的数据平台，对基础的数据、指标和报表进行加工与整合，建立数据指标体系，优化数据结构，最终归纳成业务主题， 让数据为业务服务。</div>
                <!-- <div class="button">咨询详情</div> -->
            </div>
        </div>
       <picture>
            <source srcset="@/assets/images/kx1_mb.jpg" media="(max-width:768px)" alt="">
            <img class="flashImg" src="@/assets/images/kx1.png" />
        </picture>
       <div class="lxwm bg1">
            <div class="content">
                <div class="title1 tc">产品特点</div>
                <div class="items mt5">
                    <div class="item2">
                        <div class="tc">
                            <img src="@/assets/images/kx2.png" />
                        </div>
                        <div class="minTitle2 mt10">通过对生产数据的分析，对生产进度、质量情况进行反馈，提高生产效率、降低成本。</div>
                    </div>
                    <div class="item2">
                        <div class="tc">
                            <img src="@/assets/images/kx3.png" />
                        </div>
                        <div class="minTitle2 mt10">通过对销售数据的分析，把握产品销量趋势、创利能力趋势，对产品生命周期策略和研发策略提供决策支持。</div>
                    </div>
                    <div class="item2 item3">
                        <div class="tc">
                            <img src="@/assets/images/kx4.png" />
                        </div>
                        <div class="minTitle2 mt10">通过对经销商数据的分析，查找分销体系的短板。</div>
                    </div>
                </div>
                <div class="items mt20">
                    <div class="item2">
                        <div class="tc">
                            <img src="@/assets/images/kx5.png" />
                        </div>
                        <div class="minTitle2 mt10">通过对企业CRM数据的分析，创建用户画像以实现精准营销。</div>
                    </div>
                    <div class="item2">
                        <div class="tc">
                            <img src="@/assets/images/kx6.png" />
                        </div>
                        <div class="minTitle2 mt10">通过对企业财务数据的分析，提升财务管理水平、定位单品盈利之星、提高资金利用率、降低财务费用。</div>
                    </div>
                    <div class="item2 item3">
                        <div class="tc">
                            <img src="@/assets/images/kx7.png" />
                        </div>
                        <div class="minTitle2 mt10">通过对储运数据的分析，缩短库存周期、优化物流方案。</div>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        data() {
            return {
                
            }
        },
        methods: {
            
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }

        .lxwm {
            padding: 30px 0;
            .items {
                display: flex;
                flex-wrap: wrap;
                .item2 {
                    margin-top: 20px;
                    width: 27.33%;
                    background-color: #ffffff;
                    margin-right: 3%;
                    padding: 15px 2%;
                    img {
                        width: auto;
                        height: 137px;
                        margin: 20px 0;
                    }
                    .minTitle2 {
                        color: #333333;
                        line-height: 20px;
                    }
                }
                .item3 {
                    margin-right: 0;
                    
                }
            }
        }
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
  .index {
    .flash {
      position: relative;
      padding: 0 50px;
      .gg .title {
        font-size: 24px;
      }
    }
    .flashImg {
      height: 100vh;
    }
  }
}
@media (max-width: 960px) {
  .index {
    .flash {
      .gg {
        color: #fff;
        .title {
          font-size: 20px;
        }
        .minColor2 {
            color: #fff;
            border-color: #fff;
        }
        .minTitle {
          width: 100%;
          font-size: 13px;
        }
        .button {
          padding: 6px 15px;
          margin-top: 20px;
        }
      }
    }
    .lxwm {
        .title1 {
            margin: 0;
        }
        .items {
            justify-content: space-between;
            .item2 {
                width: 100%;
                margin-right: 0;
                padding: 30px 15px;
                margin-bottom: 15px;
                .minTitle2 {
                    padding: 0 10px;
                    font-size: 14px;
                }
            }
        }
    }
    
  }
}
@media (max-width: 768px) {
    .index {
        .flash {
            padding: 0 15px;
            .minTitle {
                width: 50%;
                font-size: 13px;
                color: #fff;
                margin-top: 26px;
                padding-right: 20px;
                box-sizing: border-box;
            }
            .gg {
                top: 50px;
                .title {
                    font-size: 20px;
                    margin-top: 26px;
                }
                .button {
                    padding: 6px 15px;
                    margin-top: 20px;
                }
            }
            
        }
        .flashImg {
            height: 40vh;
        }
    }
}
</style>